import { useEffect, useState } from "react";
import { Sparkles, X } from "lucide-react";

const STORAGE_KEY = "sonoran_live_dismissed";

export default function LiveActivity() {
  const [visible, setVisible] = useState(false);
  const [closed, setClosed] = useState(false);

  useEffect(() => {
    if (typeof window === "undefined") return;
    if (sessionStorage.getItem(STORAGE_KEY) === "1") {
      setClosed(true);
      return;
    }
    let triggered = false;
    const onScroll = () => {
      if (triggered) return;
      if (window.scrollY > window.innerHeight * 0.85) {
        triggered = true;
        // small delay for natural feel
        setTimeout(() => setVisible(true), 600);
      }
    };
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const dismiss = () => {
    setClosed(true);
    try {
      sessionStorage.setItem(STORAGE_KEY, "1");
    } catch (_) {}
  };

  if (closed || !visible) return null;

  return (
    <div
      data-testid="live-activity-pill"
      className="fixed z-40 bottom-5 left-5 sm:bottom-7 sm:left-7 max-w-[calc(100vw-2.5rem)] sm:max-w-[340px]"
      style={{
        animation: "liveSlideIn 0.9s cubic-bezier(0.22, 1, 0.36, 1) both",
      }}
    >
      <div className="flex items-stretch gap-3 bg-black/75 backdrop-blur-2xl border border-white/10 pl-3 pr-2 py-3 shadow-[0_24px_60px_rgba(0,0,0,0.55)]">
        <div className="relative flex-shrink-0 w-10 h-10 bg-[#E5D0A1]/10 border border-[#E5D0A1]/30 flex items-center justify-center">
          <Sparkles className="w-4 h-4 text-[#E5D0A1]" strokeWidth={1.5} />
          <span className="absolute -top-0.5 -right-0.5 w-2 h-2 rounded-full bg-[#7CFFB2] shadow-[0_0_8px_#7CFFB2]" />
        </div>
        <div className="min-w-0 flex-1 pr-1">
          <p className="font-mono-small text-white/40 mb-1">Recently Booked</p>
          <p className="font-body text-white text-[13px] font-medium leading-tight">
            House wash booked in Paradise Valley
          </p>
          <p className="font-body text-white/45 text-[11px] mt-1">
            14 minutes ago · via 30-second quote
          </p>
        </div>
        <button
          data-testid="live-activity-close"
          onClick={dismiss}
          aria-label="Dismiss"
          className="self-start text-white/30 hover:text-white transition-colors p-1"
        >
          <X className="w-3.5 h-3.5" strokeWidth={1.5} />
        </button>
      </div>
      <style>{`
        @keyframes liveSlideIn {
          from { opacity: 0; transform: translateY(20px); }
          to { opacity: 1; transform: translateY(0); }
        }
        @media (prefers-reduced-motion: reduce) {
          [data-testid="live-activity-pill"] { animation: none !important; }
        }
      `}</style>
    </div>
  );
}
